//
// SymmetricEncrypter wraps the interface SubtleCryptoLike
// At runtime, 'window.crypto.subtle' is injected but
// the test suite injects a mocked implementation
//
import { KeyDerivation } from '@/modules/common/services/crypto/key-derivation';

const DEFAULT_KEY_ITERATIONS = 36000;

export class SymmetricEncrypter {
  private readonly keyDerivation: KeyDerivation;

  public constructor(
    derivation: KeyDerivation,
    public iterations = DEFAULT_KEY_ITERATIONS
  ) {
    this.keyDerivation = derivation;
  }

  /**
   * @param plainPassword
   * @param salt
   * @return base64 hashed password
   */
  public async hashPassword(plainPassword: string, salt: Buffer): Promise<string> {
    const buf = await this.keyDerivation.compute(
      Buffer.from(plainPassword, 'utf8'),
      salt,
      this.iterations
    );
    return buf.toString('base64');
  }
}
